import { render, staticRenderFns } from "./TagGroupDia.vue?vue&type=template&id=0ae7c20d&scoped=true&"
import script from "./TagGroupDia.vue?vue&type=script&lang=js&"
export * from "./TagGroupDia.vue?vue&type=script&lang=js&"
import style0 from "./TagGroupDia.vue?vue&type=style&index=0&id=0ae7c20d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae7c20d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae7c20d')) {
      api.createRecord('0ae7c20d', component.options)
    } else {
      api.reload('0ae7c20d', component.options)
    }
    module.hot.accept("./TagGroupDia.vue?vue&type=template&id=0ae7c20d&scoped=true&", function () {
      api.rerender('0ae7c20d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/tagsGroups/TagGroupDia.vue"
export default component.exports